export const CLIMATE = {
  MILD: 'MILD',
  NORMAL: 'NORMAL',
  CHILLY: 'CHILLY',
};

export type Climate = (typeof CLIMATE)[keyof typeof CLIMATE];

export const allClimates = () => {
  return [CLIMATE.MILD, CLIMATE.NORMAL, CLIMATE.CHILLY];
};
